"use client";

import { c as _c } from "react/compiler-runtime";
import { getApolloClient } from "@/utils/apollo/get-client";
import { ApolloProvider as ApolloClientProvider } from "@apollo/client";
import { ReactNode } from "react";
export function ApolloProvider(t0) {
  const $ = _c(5);
  const {
    children
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = getApolloClient();
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const client = t1;
  let t2;
  if ($[1] !== children) {
    t2 = children ?? <span data-testid="apollo-provider-root" />;
    $[1] = children;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t2) {
    t3 = <ApolloClientProvider client={client}>{t2}</ApolloClientProvider>;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
}